import { LevelPlayActivity } from '@/shared/level-play'

import { DigitalProductQuizQuizPlayQuestionFooter } from './Footer'
import { DigitalProductQuizQuizPlayQuestionToolbar } from './Toolbar'
import { useQuizContext } from '../../context'
import { getConfigByKind } from '../../Questions/config'

/**
 * Wrapper de domínio sobre o shell compartilhado.
 *
 * Injeta o que é do quiz — o registro de kinds, o lookup da pergunta e os
 * componentes de Footer e Toolbar. A orquestração do step vive em
 * `LevelPlayActivity`.
 */
export const DigitalProductQuizQuizPlayQuestion = () => {
  const {
    steps,
    currentStepIndex,
    methods,
    getQuestion,
    onQuestionVerifyAnswer
  } = useQuizContext()

  return (
    <LevelPlayActivity
      steps={steps}
      currentStepIndex={currentStepIndex}
      methods={methods}
      getActivity={getQuestion}
      getConfigByKind={getConfigByKind}
      onVerifyAnswer={onQuestionVerifyAnswer}
      Toolbar={DigitalProductQuizQuizPlayQuestionToolbar}
      Footer={DigitalProductQuizQuizPlayQuestionFooter}
    />
  )
}
